import { createContext, type PropsWithChildren, use, useMemo } from 'react';

const FormWizardFormStepContext = createContext<{ formRef: HTMLFormElement | null }>({
  formRef: null,
});

type FormWizardStepContextProviderProps = PropsWithChildren<{
  formRef: HTMLFormElement | null;
}>;

export function FormWizardFormStepContextProvider({ children, formRef }: FormWizardStepContextProviderProps) {
  const value = useMemo(
    () => ({
      formRef,
    }),
    [formRef],
  );

  return <FormWizardFormStepContext.Provider value={value}>{children}</FormWizardFormStepContext.Provider>;
}

export function useFormWizardFormStepContext() {
  return use(FormWizardFormStepContext);
}
